import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImportFileCsvStatus } from 'src/app/interfaces/importFileCsvStatus';
import { ImportFileXlsxStatus } from 'src/app/interfaces/importFileXlsxStatus';
import { UtilService } from 'src/app/util/util.service';
import { URL } from 'src/environments/environment';
import { ImportFileXlsxModalComponent } from '../import-file-xlsx-modal/import-file-xlsx-modal.component';
import { HistoricXlsxModalComponent } from './historic-xlsx-modal/historic-xlsx-modal.component';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
  MatExpansionPanelDescription
} from '@angular/material/expansion';
import { MatFormField, MatLabel, MatInput, MatHint, MatSuffix } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { IconModule, LinkModule, LoaderModule } from '@michelin/theme';
import { MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mic-app-import-file-xlsx',
  templateUrl: './import-file-xlsx.component.html',
  styleUrls: ['./import-file-xlsx.component.scss'],
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatFormField,
    MatLabel,
    MatInput,
    MatHint,
    MatButton,
    MatSuffix,
    MatTooltip,
    IconModule,
    LinkModule,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatIcon,
    LoaderModule
  ]
})
export class ImportFileXlsxComponent implements OnInit {
  private readonly http = inject(HttpClient);
  readonly utilService = inject(UtilService);
  dialog = inject(MatDialog);

  @Input() xlsxFunction: any;

  importFileXlsxStatus: ImportFileXlsxStatus;
  selectedSimpleFileInput: FileList;
  panelOpenState = false;
  user = JSON.parse(localStorage.getItem('user'));
  test: string;

  csvFile: ImportFileCsvStatus[] = [];
  ngOnInit(): void {
    if (this.xlsxFunction.importFileXlsxStatuses.length !== 0) {
      this.importFileXlsxStatus = this.xlsxFunction.importFileXlsxStatuses[this.xlsxFunction.importFileXlsxStatuses.length - 1];
      this.test = `${URL.url}downloadXlsxFile/${this.importFileXlsxStatus.id}`;
    }
  }
  selectSimpleFileInput(event: any) {
    this.selectedSimpleFileInput = event.target.files;
  }
  onSend() {
    const formData: FormData = new FormData();
    formData.append('file', this.selectedSimpleFileInput[0]);
    this.importFileXlsxStatus = undefined;
    this.http.post<ImportFileXlsxStatus>(`${URL.url}${URL.upload}xlsx/${this.xlsxFunction.id} `, formData, {}).subscribe((result) => {
      this.importFileXlsxStatus = result;
    });
  }

  openXlsxHistoric(): void {
    this.dialog.open(HistoricXlsxModalComponent, {
      width: '800px',
      data: this.xlsxFunction.id
    });
  }

  openUpdatedCsvFunction() {
    const dialogRef = this.dialog.open(ImportFileXlsxModalComponent, {
      width: '600px',
      data: this.xlsxFunction
    });
    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit(); // TODO update this and add only the one element to the list
    });
  }
}
